import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
import { Notification } from '../models/notification.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService extends BaseService {
  public fetchNewNotifications(): Observable<number> {
    return from(this.API.get(environment.API_NAME, `/notifications/new-count`));
  }

  public fetchNotifications(): Observable<Notification[]> {
    return from(this.API.get(environment.API_NAME, `/notifications`));
  }

  public markAsRead(notifId: string): Observable<void> {
    return from(this.API.post(environment.API_NAME, `/notifications/read/${notifId}`, {}));
  }

  private readonly API = inject(ApiService);
}
